// Copyright (c) 2017+,COMUNICARE SOLUTIONS SA
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without modification,
// are NOT permitted.

// #######################################################################################################
// Global Constants for this App
//
export class AppConstants {
  // for/like/on ROBOT
  public static get ROBOT_MODE(): boolean {
    return false;
  } // special mode on Robot
  public static get ROBOT_SIMULATION(): boolean {
    return false;
  } // only simulate speech
  public static get ROBOT_COM_PORT(): number {
    return 3030;
  } // robot http port communication

  // DEV vs PROD vs LOCAL environment
  public static get LOCAL_DEV_MODE(): boolean {
    return false;
  } // special dev mode on local PC
  public static get APP_MODE(): string {
    return "appmode";
  } // App is in Dev or Prod mode
  public static get API_URL_DEV(): string {
    return "https://testsrv.comunicare.io/api";
  } // // remote dev server (in fact test server)
  public static get API_URL_PROD(): string {
    return "https://appserver.comunicare.io/api";
  } // // remote prod server
  public static get API_URL_FORCE_DEV(): string {
    return "https://devsrv.comunicare.io/api";
  } // // remote real "dev" server
  public static get API_URL_LOCAL(): string {
    return "http://localhost:8080/api";
  } // // test on local server
  // API server for RSW
  public static get API_URL_RSW_DEV(): string {
    return "https://testsrv.comunicare.io/rsw";
  } // // remote dev server
  public static get API_URL_RSW_PROD(): string {
    return "https://appserver.comunicare.io/rsw";
  } // // remote prod server
  public static get API_URL_RSW_LOCAL(): string {
    return "http://localhost:8080/rsw";
  } // // test on local server

  public static get ABRUMET_API_DEV(): string {
    return "https://testsrv.comunicare.io/connector";
  } // // remote dev server for Abrumet QA
  public static get ABRUMET_API_PROD(): string {
    return "https://appserver.comunicare.io/connector";
  } // // remote PROD server for Abrumet PROD
  public static get ABRUMET_API_LOCAL(): string {
    return "http://localhost:8085/connector";
  } // //  test on local server for Abrumet QA

  // module parameters
  public static get RULES_MODULE(): boolean {
    return true;
  }
  public static get CAREPLAN_EDIT_MODULE(): boolean {
    return true;
  }
  public static get RSW_MODULE(): boolean {
    return true;
  }
  public static get BRUSAFE_MODULE(): boolean {
    return true;
  }
  public static get USER_AUTOLOGIN(): boolean {
    return false;
  }
  // API Version to use
  public static get CC_API_VERSION(): string {
    return "1";
  }
  // notification
  public static get NOTIF_ID_APPGENERATION_LENGTH(): number {
    return 6;
  } // length for auto generation of notification system id in the app
  public static get NOTIF_SOURCE_ALERT(): string {
    return "alert";
  } // indicates that the notification has created via an alert
  public static get NOTIF_GENERATEALL(): string {
    return "notifGenerateAll";
  } // indicates that the notification has created via an alert

  // careplan timeline
  public static get TIMELINE_MULTIPLIER(): number {
    return 3;
  } // 20 for every day
  public static get SPOT_WIDTH(): number {
    return 20;
  }
  public static get TIMELINE_HEIGHT(): number {
    return 36;
  } // visual height of a timeline
  public static get TIMELINE_UNIT(): string {
    return "px";
  }
  // Events
  public static get EV_SYNCINPROGRESS(): string {
    return "app:syncinprogress";
  } // synchro in progress
  public static get EV_STARTSYNC(): string {
    return "app:sync";
  } // synchro has to be done
  public static get EV_SYNCDONE(): string {
    return "app:syncdone";
  } // synchro done
  public static get EV_LATERSYNC(): string {
    return "app:latersync";
  } // synchro was not done for the moment
  public static get EV_LOGIN(): string {
    return "app:login";
  } // login success
  public static get EV_DATAUPDATED(): string {
    return "app:dataupdated";
  } // something updated...
  public static get EV_LOGOUT(): string {
    return "app:logout";
  }
  public static get EV_NOTIF_COMPUTING(): string {
    return "notification:computing";
  } // notification service computing in progress...
  public static get EV_NOTIF_UPDATED(): string {
    return "notification:updated";
  }
  public static get EV_NOTIF_REGENERATE(): string {
    return "notification:regenerate";
  }
  public static get EV_DRUG_DELETED(): string {
    return "drug:deleted";
  }
  public static get EV_CAREDETAILS(): string {
    return "careplan:details";
  }
  public static get EV_MESSAGE_UPDATED(): string {
    return "messages:update";
  }
  public static get EV_APPOINTMENT_UPDATED(): string {
    return "appointment:update";
  }
  public static get EV_REFRESH_APPCOMPONENT(): string {
    return "refresh:appcomponent";
  }
  public static get EV_GOTOHOMEPAGE(): string {
    return "gotoHomePage";
  }
  public static get EV_DISPLAYNOTIFICATION(): string {
    return "homepage:displaynotification";
  }
  public static get EV_SECURESTORAGENOTACTIVE(): string {
    return "securestorage:notactive";
  }
  public static get EV_SECURESTORAGEACTIVE(): string {
    return "securestorage:active";
  }
  public static get EV_SYNCREQUESTSENDER(): string {
    return "sync:requestsender";
  }
  public static get EV_GOTOLOGINPAGE(): string {
    return "gotoLoginPage";
  }
  public static get EV_LOADDRUGDATA(): string {
    return "loadDrugData";
  }

  // public static get EV_TABS_MYDRUGS_DATAUPDATED(): string { return "tabs:mydrugsdataupdated" }
  public static get EV_CARPLAN_DATAUPDATED(): string {
    return "careplan:updated";
  } // a careplan has been updated/modified
  // *** local parameters ***
  public static get PRM_READ_SHDATA(): string {
    return "readSHdata";
  }
  public static get PRM_READ_GAHDATA(): string {
    return "readGAHdata";
  }
  public static get PRM_CAREPLAN_BADGE(): string {
    return "careplanBadge";
  } // last time careplans has been seen (used to hide badge)
  public static get PRM_APPOINTMENT_BADGE(): string {
    return "appointmentBadge";
  } // last time appointments has been seen (used to hide badge)
  public static get PRM_BLUETOOTH_DEVICE(): string {
    return "bluetoothdevice";
  }
  public static get PRM_NOTIFICATION_COUNT(): string {
    return "notifcount";
  }
  public static get PRM_HELP_SEEN(): string {
    return "helpSeen";
  } // help has been seen on pages
  public static get PRM_ABRUMET_POPUP_DATE(): string {
    return "AbrumetPopUp";
  }
  public static get PRM_ACTIVITY_REPORT_POPUP_DATE(): string {
    return "ActivitySyncPopUp";
  }

  // BRUSAFE
  public static get PRM_SHARE_BRUSAFE_LOGIN(): string {
    return "syncBrusafeLogin";
  }
  public static get PRM_SHARE_BRUSAFE_CAREPLAN(): string {
    return "syncBrusafeCareplan";
  }
  public static get PRM_SHARE_BRUSAFE_OBSERVATION(): string {
    return "syncBrusafeObservation";
  }
  public static get PRM_SHARE_BRUSAFE_QUESTIONNAIRE(): string {
    return "syncBrusafeQuestionnaire";
  }
  public static get PRM_SHARE_BRUSAFE_DRUG(): string {
    return "syncBrusafeDrug";
  }
  // RSW
  public static get PRM_SHARE_RSW_GUID(): string {
    return "shareRswGuid";
  }
  public static get PRM_SHARE_RSW_CAREPLAN(): string {
    return "shareRswCareplan";
  }
  public static get PRM_SHARE_RSW_OBSERVATION(): string {
    return "shareRswObservation";
  }
  public static get PRM_SHARE_RSW_QUESTIONNAIRE(): string {
    return "shareRswQuestionnaire";
  }
  public static get PRM_SHARE_RSW_DRUG(): string {
    return "shareRswDrug";
  }
  // session timeout
  public static get PRM_SESSION_ACTIVITY_TIMEOUT(): string {
    return "sessionActivityTimeout";
  } //  session timeout
  public static get PRM_SESSION_ACTIVITY(): string {
    return "sessionActivity";
  } // store user activity for local session timeout
  public static get SESSION_TIMEOUT_CHECKINTERVAL(): number {
    return 15 * 60 * 1000;
  } // check session every 15min (in ms)
  // others
  public static get PRM_FIRST_LAUNCH(): string {
    return "FirstLaunch";
  }
  public static get PRM_NO_ADVICE(): string {
    return "noadvice";
  }
  public static get PASSWORD_MINLENGTH(): number {
    return 8;
  }
  public static get CRYPTO_IV(): string {
    return "951b9df02e58eb5a";
  }
  public static get MONGO_ID_SIZE(): number {
    return 24;
  }
  public static get PRM_LAST_LOGIN(): string {
    return "lastLogin";
  }
  public static get PRM_SERVER_ACCESS(): string {
    return "lastServer";
  }
  public static get PRM_ASK2UPDATE_APP(): string {
    return "ask2update";
  }
  public static get ADVICE_DEFAULT_FREQUENCY(): number {
    return 1;
  }
  public static get NO_END_DATE(): string {
    return "9999-12-31";
  }
  public static get IONIC5CLEAR(): string {
    return "ionic5Clear";
  } // App is in Dev or Prod mode

  // User Credential types (for external connectors)
  public static get CREDENTIAL_ABRUMET(): string {
    return "abrumet";
  } // Abrumet Connector
  public static get CREDENTIAL_CHULG(): string {
    return "chulg";
  } // CHU Liège Connector
  public static get CREDENTIAL_RSW(): string {
    return "rsw";
  } // RSW Connector
  // Page Name
  public static get PAGE_LOGIN(): string {
    return "Login";
  }
  public static get PAGE_HOME(): string {
    return "Home";
  }
  public static get PAGE_ABOUT(): string {
    return "About";
  }
  public static get PAGE_ACCOUNT(): string {
    return "Account";
  }
  public static get PAGE_APPOINTMENT(): string {
    return "Appointment";
  }
  public static get PAGE_DRUG(): string {
    return "Drug";
  }
  public static get PAGE_CAREPLAN(): string {
    return "Careplan";
  }
  public static get PAGE_CAREPLAN_WIZARD(): string {
    return "CareplanWizard";
  }
  public static get PAGE_CAREPLAN_ACTIVITY(): string {
    return "CareplanActivity";
  }
  public static get PAGE_DRUGS(): string {
    return "Drugs";
  }
  public static get PAGE_KNOWLEDGE(): string {
    return "Knowledge";
  }
  public static get PAGE_AGENDA(): string {
    return "Agenda";
  }
  public static get PAGE_OBSERVATION(): string {
    return "Observation";
  }
  public static get PAGE_OBSERVATIONS(): string {
    return "Observations";
  }
  public static get PAGE_FEELINGS(): string {
    return "Feelings";
  }
  public static get PAGE_SURVEY(): string {
    return "Survey";
  }
  public static get PAGE_ADVICES(): string {
    return "Advices";
  }
  public static get PAGE_ENTOURAGE(): string {
    return "Entourage";
  }
  public static get PAGE_HEALTH(): string {
    return "Health";
  }
  public static get PAGE_NOTE(): string {
    return "Note";
  }
  public static get PAGE_NOTES(): string {
    return "Notes";
  }
  public static get PAGE_2FA(): string {
    return "2FA";
  }
  public static get PAGE_PWDRESET(): string {
    return "PasswordReset";
  }
  public static get PAGE_SETTINGS(): string {
    return "Settings";
  }
  public static get PAGE_SHARE(): string {
    return "Share";
  }
  public static get PAGE_LINKS(): string {
    return "Links";
  }
  public static get PAGE_BLUETOOTH(): string {
    return "Bluetooth";
  }
  public static get PAGE_RECOMMENDATION(): string {
    return "Recommendation";
  }
  public static get PAGE_MESSAGES(): string {
    return "Messages";
  }
  public static get PAGE_REWARDS(): string {
    return "Rewards";
  }

  public static get ERROR_ServerUnreachable(): string {
    return "ServerUnreachable";
  }
  public static get ERROR_CommunicationError(): string {
    return "Communication error";
  }
  public static get ERROR_NotLoginPageSet(): string {
    return "Not Login Page Set";
  }
  public static get ERROR_OFFLINE_INSTEAD_OF_ONLINE(): string {
    return "ERROR_OFFLINE_INSTEAD_OF_ONLINE";
  }

  public static get MEETJITSI(): string {
    return "meetjitsi";
  }
  // cookies and localStorage key name
  public static get ACCOUNT(): string {
    return "account_list";
  }
  public static get SYS_ACCOUNT(): string {
    return "sysaccount";
  }
  public static get CAREPLANS(): string {
    return "careplans_list";
  }
  public static get OBS_EXPORT_DATA(): string {
    return "observation_export_data";
  }

  // URL for dynamic images
  public static get URL_IMG_AGENDA(): string {
    return "assets/image/agenda.png";
  }
  public static get URL_IMG_AGENDA_MIN(): string {
    return "assets/image/agenda-min.png";
  }
  public static get URL_IMG_NOTES(): string {
    return "assets/image/notes.png";
  }
  public static get URL_IMG_NOTES_MIN(): string {
    return "assets/image/notes-min.png";
  }

  // Observation modal id
  public static get OBSERVATION_MODAL(): string {
    return "observationModal";
  }

  // Settings modal id
  public static get SETTINGS_MODAL(): string {
    return "settingsModal";
  }

  // tabs name
  public static get TABS_AGENDA(): string {
    return "agenda";
  }

  public static get REQUIRED_SYNCHRO_TIME(): number {
    return 5;
  }
  public static get BACKGROUNDSYNCHROPLUGIN_HOUR(): number {
    return 3;
  }
  public static get BACKGROUND_minimumFetchInterval(): number {
    return 15;
  }
  public static get ABRUMET_HELP(): string {
    return "https://auth.brusafe.be/portal/patient/index.xhtml";
  }

  public static get KEY_SECURESTORAGE_NOT_ACTIVE(): string {
    return "key:securestoragenotactive";
  }
  public static get KEY_EXISTSQLSTORAGE(): string {
    return "key:existSQLStorage";
  }

  public static get GOOGLE_API_NOT_READY(): string {
    return "GoogleApiClient is not connected yet.";
  }

  public static get STORAGE_NAME(): string {
    return "storagecare";
  }

  public static get MAIN_MENU_NAME(): string {
    return "textMenu";
  }

  public static get FINGERPRINT_DATA(): string {
    return "fingerprint_data";
  }

  public static get SOMEONE_LOGIN(): string {
    return "someoneLogIn";
  }

  public static get ASSOCIATION_USER_PASSWORD(): string {
    return "associationUserPassword";
  }

  public static get ACTIVE_DRUGS_ONLY(): string {
    return "activeDrugsOnly";
  }

  public static get DEEPLINK_MODE_DEV(): string {
    return "dev";
  }
  public static get DEEPLINK_MODE_PROD(): string {
    return "prod";
  }
  public static get DEEPLINK_MODE_TEST(): string {
    return "test";
  }
  public static get DEEPLINK_VALID_MODE(): string[] {
    return [this.DEEPLINK_MODE_PROD, this.DEEPLINK_MODE_TEST, this.DEEPLINK_MODE_DEV];
  }

  // TIMING CODE
  public static get RISING(): string {
    return "rising";
  }
  public static get BEDING(): string {
    return "beding";
  }

  // physical activity loinc
  public static get PHYSICAL_ACTIVITY_LOINC(): string {
    return "LG41761-4";
  }

  public static get NEW_INSTALLATION_FROM_STORE(): string {
    return "NEW_INSTALLATION_FROM_STORE";
  }
  public static get TRUE(): string {
    return "true";
  }
  public static get FALSE(): string {
    return "false";
  }
  public static get LANGUAGES_LIST(): string {
    return "languages_list";
  }
  public static get LAST_LANGUAGE(): string {
    return "last_language";
  }
  public static get TRANSLATIONS_KEYS(): string {
    return "translation_i18n_";
  }

  // Comunicare patient satisfaction questionnaire id
  public static get SAT_PATIENT_COMUNICARE(): string {
    return "SAT-PATIENT-COMUNICARE";
  }

  public static get PILLDISPENSER(): string {
    return "pilldispenser";
  }
}
